module.exports = __webpack_public_path__ + "img/htx.4165571e.png";